<template>
  <div class="indexBannerFiltersWrapper">
    <div class="indexBannerFilters">
      <ul
        class="itemWrapper"
        v-for="currentFilter in selectedFilters"
        :key="currentFilter.tagId"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="400"
      >
        <li
          class="preselected-item"
          :class="
            selectedFilter?.tagId &&
              currentFilter.tagId === selectedFilter.tagId &&
              'active'
          "
        >
          <button
            tabindex="0"
            @click="clickFilters(currentFilter.tagId)"
            :aria-label="currentFilter.tagName"
          >
            <div class="icon">
              <picture>
                <source
                  :srcset="currentFilter.image"
                  media="(min-width: 767px)"
                />
                <source
                  :srcset="currentFilter.imageMobile"
                  media="(min-width: 0px)"
                />
                <img :src="currentFilter.image" alt="" role="presentation" />
              </picture>
            </div>

            <span :id="`tag_${currentFilter.tagId}`">{{
              currentFilter.tagName
            }}</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { SelectedCtaModel } from "../clients/search/src/models";

export default defineComponent({
  props: {
    selectedFilter: {
      type: Object as PropType<SelectedCtaModel>,
      required: true,
      default: undefined
    },
    selectedFilters: {
      type: Array as PropType<SelectedCtaModel[]>,
      required: true,
      default: () => []
    }
  },
  setup(props, context) {
    const clickFilters = (tagId) => {
      context.emit("preSelectedFilterClick", tagId, props.selectedFilters);
    };

    return {
      clickFilters
    };
  }
});
</script>
